import React, { CSSProperties, JSX } from "react";
import styled, { css } from "styled-components";
import { SlidingContainer } from "@ui/components/containers/slidingContainer";
import { mobile } from "@ui/styles/utils";
import { ClosableModal, ClosableModalProps, ModalTitle } from "./closableModal";

interface SlidingModalProps extends ClosableModalProps {
	currentIndex: number;
	elements: JSX.Element[];
	tabStyle?: CSSProperties;
	sharedTitle?: boolean;
}

export const SlidingModal: React.FC<SlidingModalProps> = ({
	currentIndex,
	elements,
	title,
	lightTitle,
	sharedTitle,
	keyboardEventDisabled,
	close,
	...props
}) => {
	const modalProps = { keyboardEventDisabled, close, ...(sharedTitle ? { title, lightTitle } : {}) };
	return (
		<StyledClosableModal {...modalProps} margedTitle={sharedTitle} layout>
			<SlidingContainer
				currentIndex={currentIndex}
				elements={elements.map((el, i) => (
					<TabWrapper key={i} {...props}>
						{title && !sharedTitle && (
							<ModalTitle className="modal-title" light={lightTitle}>
								{title}
							</ModalTitle>
						)}
						{el}
					</TabWrapper>
				))}
			/>
		</StyledClosableModal>
	);
};

const StyledClosableModal = styled(ClosableModal).withConfig({
	shouldForwardProp: (prop) => prop !== "margedTitle",
})<{ margedTitle?: boolean }>`
	padding: 0;
	overflow: hidden;

	.modal-title {
		${({ margedTitle }) =>
			margedTitle &&
			css`
				margin-top: 50px;
				margin-left: 65px;
				@media ${mobile} {
					margin-top: 50px;
					margin-left: 20px;
				}
			`}
	}
`;

const TabWrapper = styled.div`
	padding: 50px 65px;
	@media ${mobile} {
		padding: 50px 20px 20px;
	}
	display: flex;
	flex-direction: column;
	align-items: stretch;
`;
